<template>
    <div>
        <div :class="{ 'has-error': cityNotSelected }">
            <input type="text"
                   :name="name"
                   class="form-control main-enter"
                   autocomplete="off"
                   :placeholder="placeholder"
                   :id="id"
                   v-model="query"/>
        </div>

        <transition name="fade">
            <ul v-click-outside="clearResults" class="address-results" style="width: 100%;" v-if="showResults">
                <li :key="index" v-bind:class="{'active-address-result': currentItem === index}"
                    class="single-address-result " v-for="(result, index) in results" v-if="result.city"
                    @click="setAddress(result)">
                    <span v-if="result.street">
                        <strong>
                            {{ result.street }}
                            {{ result.houseNumber ? result.houseNumber + ', ' : '' }}
                        </strong>
                    </span>
                    <strong v-if="result.city">{{ result.city }}</strong>
                    <em v-if="result.county">{{ '| ' + result.county }} </em>
                    <em v-if="result.city">{{ '| ' + result.country }} </em>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import debounce from 'debounce';

export default {
    name: "HereAddressLookup",

    props: {
        id: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        on_form: {
            type: Boolean,
            default: false
        },
        app_key: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        cityNotSelected: {
            type: Boolean,
        }
    },

    data() {
        return {
            results: {},
            showResults: false,
            query: "",
            address: {},
            selectedValue: '',
            currentItem: 0,
            isSearchingLocation: false,
        };
    },

    created() {
        this.debouncedQuery = debounce(this.fetchAutocompleteResults, 1000);
    },

    watch: {
        query: function (value) {
            this.debouncedQuery(value);
        }
    },

    methods: {
        fetchAutocompleteResults(value) {
            this.selectedValue = '';

            if (!value) {
                return;
            }

            fetch(`https://autocomplete.search.hereapi.com/v1/autocomplete?q=${value}&apiKey=${this.app_key}`)
                .then(result => result.json())
                .then(result => {
                    if (result.items && result.items.length > 0) {

                        this.showResults = this.query !== this.value;

                        let final_results = [];
                        let api_results = result.items;
                        let item = '';
                        let itemAddress = '';

                        Object.keys(api_results).forEach(key => {

                            item = api_results[key];
                            itemAddress = item.address;

                            if (!this.inArray(itemAddress, final_results)) {
                                if (itemAddress.city && typeof itemAddress.street === 'undefined') {
                                    final_results.push(JSON.parse(JSON.stringify({
                                        city: itemAddress.city,
                                        county: itemAddress.county,
                                        country: itemAddress.countryName,
                                        countryCode: itemAddress.countryCode,
                                        locationId: item.id,
                                        matchLevel: item.resultType,
                                        district: itemAddress.district ? itemAddress.district : false
                                    })));
                                }

                                if (typeof itemAddress.street !== 'undefined') {
                                    final_results.push(JSON.parse(JSON.stringify({
                                        street: itemAddress.street,
                                        houseNumber: itemAddress.houseNumber ? itemAddress.houseNumber : '',
                                        city: itemAddress.city,
                                        county: itemAddress.county,
                                        country: itemAddress.countryName,
                                        countryCode: itemAddress.countryCode,
                                        locationId: item.id,
                                        matchLevel: item.resultType,
                                        district: itemAddress.district ? itemAddress.district : false
                                    })));
                                }
                            }
                        });

                        if (!itemAddress.county || !itemAddress.city || !itemAddress.street) {
                            $('#invalid-address').show();
                        } else {
                            $('#invalid-address').hide();
                        }

                        this.results = final_results;
                    } else {
                        this.clearResults();
                    }
                })
                .catch((e) => {
                    console.log('e', e);
                });
        },
        fillAddress(result) {
            let Vue = this;

            if (result.street) {
                let houseNumber = result.houseNumber ? " " + result.houseNumber + ", " : ', ';
                Vue.selectedValue = result.street + houseNumber + result.city + ", " + result.country;

                $('#invalid-address').hide();
            } else {
                Vue.selectedValue = result.city + ", " + result.country;

                $('#invalid-address').show();
            }

            $('#' + this.id).val(Vue.selectedValue);

        },
        setAddress(result) {
            if (typeof result === 'undefined') {
                return;
            }

            if (this.isSearchingLocation) {
                return;
            }

            let Vue = this;

            this.isSearchingLocation = true;
            Vue.$emit('searching-location', true);

            fetch(`https://lookup.search.hereapi.com/v1/lookup?id=${result.locationId}&apiKey=${this.app_key}`)
                .then(location => location.json())
                .then(location => {

                    if (typeof location !== 'undefined') {

                        let city = location.address.city;

                        Vue.address = {
                            locality: city.replace('ü', 'ue').replace('ö', 'oe').replace('ä', 'ae'),
                            country: location.address.countryName,
                            latitude: location.position.lat,
                            longitude: location.position.lng,
                            route: location.address.street ? location.address.street : '',
                            houseNumber: result.houseNumber ? result.houseNumber : '',
                        };

                        let country = location.address.countryCode ? location.address.countryCode : '';

                        if (Vue.on_form) {
                            $('#country_long').val(Vue.address.country);
                            $('#country').val(country);
                            $('#locality').val(Vue.address.locality);
                            $('#lat').val(Vue.address.latitude);
                            $('#lng').val(Vue.address.longitude);
                            $('#route').val(Vue.address.route);
                            $('#street_number').val(Vue.address.houseNumber);
                        }

                        Vue.address.country_iso = country;

                        Vue.$emit("address", Vue.address);
                        Vue.fillAddress(result);

                    } else {
                        iziToast.show({
                            title: "Something went wrong.",
                            color: 'red'  // blue, red, green, yellow
                        });
                    }

                    this.isSearchingLocation = false;
                    Vue.$emit('searching-location', false);
                })
                .catch((e) => {
                    if (result.countryCode === 'JPN') {
                        let city = result.city;

                        Vue.address = {
                            locality: city.replace('ü', 'ue').replace('ö', 'oe').replace('ä', 'ae'),
                            country: result.country,
                        };

                        if (Vue.on_form) {
                            $('#country_long').val(Vue.address.country);
                            $('#country').val(result.countryCode);
                            $('#locality').val(Vue.address.locality);
                        }

                        Vue.address.country_iso = result.countryCode;

                        Vue.$emit("address", Vue.address);
                        Vue.fillAddress(result);
                    } else {
                        iziToast.show({
                            title: "Something went wrong.",
                            color: 'red'  // blue, red, green, yellow
                        });
                    }

                    this.isSearchingLocation = false;
                    Vue.$emit('searching-location', false);
                });

            Vue.clearResults();
        },
        clearResults() {
            if (this.results[this.currentItem]) {
                this.setAddress(this.results[this.currentItem]);
            }

            this.showResults = false;
            this.results = {};
            this.currentItem = 0;
        },
        inArray(needle, haystack) {
            let i = 0;
            let found = false;

            for (i; i < haystack.length; i++) {
                found = haystack[i].city === needle.city
                    && haystack[i].county === needle.county
                    && haystack[i].country === needle.country
                    && needle.district !== false;

                if (found) {
                    break;
                }
            }

            return found;
        },
        handleKeyDown(event) {
            if (this.currentItem > -1) {
                if (event.keyCode === 38 && this.currentItem > 0) {
                    this.currentItem--;

                } else if (event.keyCode === 40 && this.currentItem < Object.keys(this.results).length) {
                    this.currentItem++;
                }

                if (event.keyCode === 13) {
                    event.preventDefault();

                    this.setAddress(this.results[this.currentItem]);
                }
            }
        },
    },

    mounted() {
        this.query = this.value;
        this.showResults = false;

        let citySelectField = document.getElementById('citySelect');
        let topSearchField = document.getElementById('topSearch');
        let homeSearchField = document.getElementById('homeSearch');

        if (citySelectField) {
            citySelectField.addEventListener('keydown', this.handleKeyDown);
        }

        if (topSearchField) {
            topSearchField.addEventListener('keydown', this.handleKeyDown);
        }

        if (homeSearchField) {
            homeSearchField.addEventListener('keydown', this.handleKeyDown);
        }
    },
}
</script>

<style scoped>
.information {
    width: 50%;
    margin: 15px 0;
}

.information input {
    width: 100%;
    padding: 5px;
    margin: 5px 0;
}

.address-results {
    background: #ffffff;
    position: absolute;
    width: 100%;
    z-index: 999;
    list-style-type: none;
    padding: 0;
    border: 1px solid #e9e9e9;
    border-top-width: 0;
    text-align: left;
}

.single-address-result {
    padding: 8px 15px;
}

.single-address-result:hover {
    background: rgba(130, 130, 130, 0.15);
    color: rgba(54, 54, 54, 0.6);
    cursor: pointer;
}

.active-address-result {
    background: #7F9741;
    color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HereAddressLookup.vue